"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fontValues = void 0;
exports.fontValues = {
    $primaryFont: 'Good Sans, Helvetica',
    $secondaryFont: 'IBM Plex, Helvetica',
    $tertiaryFont: 'Good Sans, Helvetica',
};
